import React from "react";
import PropTypes from 'prop-types';
import SvgIcon from "../../../Helpers/Svg/SvgIcon";
import PermBannerImg from '../../../../assets/tools/perm_banner.jpg'
import "./PromotedProduct.scss";

export default function PromotedProduct({icon, title, subTitle, buttonText, hasBackgroundImage, backgroundImage, ctaType, redirectUri, filter, handlePromotedProduct}) {

  return (
    <button 
      className={`promoted-product ${hasBackgroundImage ? "PromotedProductBackgroundImage has-bg-image" : "PromotedProductBackgroundColor"}`} 
      onClick={() => handlePromotedProduct(ctaType, filter, redirectUri)}
      style={{'--promoted-product-bg-image': (backgroundImage ? `url(${backgroundImage})` : `url(${PermBannerImg})`)}}
      >
      <div className="content-group">
        <div className="icon-container">
          <SvgIcon iconName={icon} className={`${hasBackgroundImage ? "" : "primary-color"}`} />
        </div>
        <h3>{title}</h3>
        <p>{subTitle}</p>
      </div>
      <label className={`${hasBackgroundImage ? "" : "primary-color"}`}>{buttonText}</label>
    </button>
  );
}

PromotedProduct.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string,
  ctaType: PropTypes.string.isRequired,
  redirectUri: PropTypes.string,
  filter: PropTypes.string,
  handlePromotedProduct: PropTypes.func.isRequired,
};
